import script from "./CallControls.vue?vue&type=script&setup=true&lang=js"
export * from "./CallControls.vue?vue&type=script&setup=true&lang=js"

import "./CallControls.vue?vue&type=style&index=0&id=f1f24b62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f24b62"]])

export default __exports__